import { Calendar, Gift, Package, Percent, Tag, TrendingUp, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { baseURL, productBaseURL } from "../../../../Services/api/baseURL";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";

const CreateCampaignModal = ({ onClose, onCreate, editData, onUpdate }) => {

  const [step, setStep] = useState(1);
  const [productsData, setProductsData] = useState([])
  const [collectionData, setCollectionData] = useState([])
  const [productSearch, setProductSearch] = useState('')
  const [categoryDrop, setCategoryDrop] = useState(false)
  const [tagSearch, setTagSearch] = useState('')
  const [tagsData, setTagsData] = useState([]);
  const dropdownRef = useRef(null)
  const dropdownTagRef = useRef(null)
  const dropdownCatRef = useRef(null)
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    status: 'draft',
    schedule: {
      startDate: '',
      endDate: '',
      //   timezone: 'Asia/Kolkata',
      daysOfWeek: [],
      timeRestrictions: {  // ADD THIS
        enabled: false,
        startTime: '',
        endTime: ''
      }
    },
    targetConditions: {
      products: { enabled: false, productIds: [], variantIds: [] },
      categories: { enabled: false, categoryIds: [] },
      channels: { enabled: false, channelList: [] },
      customerTags: { enabled: false, tagIds: [], specificCustomers: [] },
      orderCriteria: { enabled: false, minOrderValue: '', maxOrderValue: '' }
    },
    boostType: 'multiplier',
    boostValue: {
      multiplier: 2,
      fixedPoints: '',
      replacementRate: ''
    },
    caps: {
      maxPointsPerOrder: '',
      maxPointsPerCustomer: '',
      resetPeriod: 'none',
      globalLimit: { enabled: false, maxTotalPoints: '' },
      maxUsesPerCustomer: '',
      maxTotalUses: ''
    },
    stacking: {
      allowStacking: true,
      priority: 5,
      stackingMode: 'multiplicative'
    },
    displayToCustomers: true,
    badgeText: ''
  });

  useEffect(() => {
    if (editData) {
      const formatted = {
        ...editData,
        schedule: {
          ...editData.schedule,
          startDate: moment(editData.schedule.startDate).format("YYYY-MM-DD"),
          endDate: moment(editData.schedule.endDate).format("YYYY-MM-DD"),
        },
        targetConditions: {
          ...editData.targetConditions,
          products: {
            ...editData.targetConditions?.products,
            variantIds: (editData.targetConditions?.products?.variantIds || []).map(
              v => (typeof v === 'object' && v !== null ? v._id : v)
            ),
          },
        },
      };

      setFormData(formatted);
    }
  }, [editData]);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProductSearch('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownTagRef.current && !dropdownTagRef.current.contains(event.target)) {
        setTagSearch('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownCatRef.current && !dropdownCatRef.current.contains(event.target)) {
        setCategoryDrop(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleSubmit = (e) => {

    e.preventDefault();
    if (editData) {
      onUpdate(editData._id, formData); // ✅ update mode
    } else {
      onCreate(formData);               // ✅ create mode
    }

  };

  const fetchItems = async () => {
    const token = await JSON.parse(localStorage.getItem("token"))
    try {
      let params = {};
      const userData = await JSON.parse(localStorage.getItem('UserData'))
      const userRole = JSON.parse(localStorage.getItem('role_name'));

      if (userRole === 'store') {
        params = {
          role: userRole,
          storeId: userData?._id
        };
      }

      const products = await axios.get(`${productBaseURL}/products/get-products`, {
        params: params,
        headers: {
          Authorization: `${token}`,
        }
      })

      const productsData = products?.data?.data
      setProductsData(productsData.reverse());

    } catch (error) {
      console.log(error, 'error from items getting')
    }
  }


  const fetchTags = async () => {
    //   setIsLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const params = {};

      // if (searchTerm) params.search = searchTerm;
      // if (categoryFilter) params.category = categoryFilter;

      const response = await axios.get(`${baseURL}/api/tags`, {
        params,
        headers: { Authorization: token },
      });

      if (response.status === 200) {
        setTagsData(response.data.data);
      }
    } catch (error) {
      toast.error("Failed to fetch tags");
      console.error(error);
    } finally {
      // setIsLoading(false);
    }
  };
  const fetchCategories = async () => {
    //   setIsLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const params = {};

      // if (searchTerm) params.search = searchTerm;
      // if (categoryFilter) params.category = categoryFilter;

      const response = await axios.get(`${baseURL}/api/tags`, {
        params,
        headers: { Authorization: token },
      });

      if (response.status === 200) {
        setTagsData(response.data.data);
      }
    } catch (error) {
      toast.error("Failed to fetch tags");
      console.error(error);
    } finally {
      // setIsLoading(false);
    }
  };
  const fetchCollections = async (page) => {
    const token = await JSON.parse(localStorage.getItem("token"))
    try {
      const collectData = await axios.get(`${baseURL}/api/admin/get-collections`, {
        headers: {
          Authorization: `${token}`,
        }
      })
      setCollectionData(collectData.data.data);

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => { fetchItems(); fetchTags(); fetchCollections() }, [])

  const updateField = (path, value) => {
    const keys = path.split('.');
    setFormData(prev => {
      const newData = { ...prev };
      let current = newData;
      for (let i = 0; i < keys.length - 1; i++) {
        current[keys[i]] = { ...current[keys[i]] };
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
      return newData;
    });
  };

  const daysOfWeek = [
    { value: 0, label: 'Sun' },
    { value: 1, label: 'Mon' },
    { value: 2, label: 'Tue' },
    { value: 3, label: 'Wed' },
    { value: 4, label: 'Thu' },
    { value: 5, label: 'Fri' },
    { value: 6, label: 'Sat' }
  ];

  const toggleDay = (day) => {
    const current = formData.schedule.daysOfWeek;
    const newDays = current.includes(day)
      ? current.filter(d => d !== day)
      : [...current, day];
    updateField('schedule.daysOfWeek', newDays);
  };

  const variantsData = productsData.flatMap(product =>
    (product.variants || []).map(variant => ({
      ...variant,
      productName: product.productName,
      brand: product.brand,
      category: product.category,
      subCategory: product.subCategory,
    }))
  );

  const filteredVariants = variantsData.filter(variant =>
    variant.variantName?.toLowerCase().includes(productSearch.toLowerCase()) ||
    variant.productName?.toLowerCase().includes(productSearch.toLowerCase()) ||
    variant.brand?.brandName?.toLowerCase().includes(productSearch.toLowerCase()) ||
    variant.category?.collection_name?.toLowerCase().includes(productSearch.toLowerCase())
  );
  const filteredTags = tagsData.filter(tag =>
    tag.name.toLowerCase().includes(tagSearch.toLowerCase())
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b px-6 pt-3 flex justify-between items-center z-10">
          <div>
            <h2>{editData ? "Edit Boost Campaign" : "Create Boost Campaign"}</h2>

            <p className="text-sm text-gray-600">Step {step} of 4</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} onKeyDown={(e) => {
          if (e.key === 'Enter' && step < 4) {
            e.preventDefault();
          }
        }}>
          <div className="p-6">
            {step === 1 && (
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Basic Information</h3>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Campaign Name *</label>
                  <input
                    type="text"
                    // required
                    value={formData.name}
                    onChange={(e) => updateField('name', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="e.g., Weekend Double Points"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                  <textarea
                    value={formData.description}
                    onChange={(e) => updateField('description', e.target.value)}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Internal description for admin reference"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Start Date *</label>
                    <input
                      type="date"
                      //   required
                      value={formData.schedule.startDate}
                      onChange={(e) => updateField('schedule.startDate', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">End Date *</label>
                    <input
                      type="date"
                      //   required
                      value={formData.schedule.endDate}
                      onChange={(e) => updateField('schedule.endDate', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Active on Days (optional)</label>
                  <div className="flex gap-2">
                    {daysOfWeek.map(day => (
                      <button
                        key={day.value}
                        type="button"
                        onClick={() => toggleDay(day.value)}
                        className={`px-3 py-2 rounded-lg text-sm font-medium transition ${formData.schedule.daysOfWeek.includes(day.value)
                            ? 'bg-[#d3178a] text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                      >
                        {day.label}
                      </button>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">Leave empty for all days</p>
                </div>
                {/* Time Restrictions */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <span className="font-medium text-gray-900">Time Restrictions (optional)</span>
                      <p className="text-xs text-gray-500">Run campaign only during specific hours</p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.schedule.timeRestrictions?.enabled || false}
                        onChange={(e) => updateField('schedule.timeRestrictions.enabled', e.target.checked)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>

                  {formData.schedule.timeRestrictions?.enabled && (
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Start Time</label>
                        <input
                          type="time"
                          value={formData.schedule.timeRestrictions?.startTime || ''}
                          onChange={(e) => updateField('schedule.timeRestrictions.startTime', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">End Time</label>
                        <input
                          type="time"
                          value={formData.schedule.timeRestrictions?.endTime || ''}
                          onChange={(e) => updateField('schedule.timeRestrictions.endTime', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div className="col-span-2">
                        <p className="text-xs text-gray-500">
                          Example: Set 18:00 - 20:00 for "Happy Hour" (6 PM - 8 PM)
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                  <select
                    value={formData.status}
                    onChange={(e) => updateField('status', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="draft">Draft</option>
                    <option value="active">Active</option>
                    <option value="paused">Paused</option>
                  </select>
                </div>
              </div>
            )}

            {step === 2 && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Target Conditions</h3>

                <div className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <Package size={20} className="text-blue-600" />
                      <span className="font-medium text-gray-900">Specific Variants</span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.targetConditions.products.enabled}
                        onChange={(e) => updateField('targetConditions.products.enabled', e.target.checked)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                  {formData.targetConditions.products.enabled && (
                    <div className="space-y-3" >

                      {formData.targetConditions.products.variantIds.length > 0 && (
                        <div className="space-y-2">
                          <div className="text-xs font-medium text-gray-700">
                            Selected Variants ({formData.targetConditions.products.variantIds.length}):
                          </div>
                          <div className="flex flex-wrap gap-2 max-h-40 overflow-y-auto p-2 bg-gray-50 rounded-lg">
                            {formData.targetConditions.products.variantIds.map(variantId => {
                              const variant = variantsData.find(v => v._id === variantId);
                              if (!variant) return null;
                              return (
                                <div
                                  key={variantId}
                                  className="flex items-center gap-2 bg-blue-100 text-blue-800 px-3 py-1.5 rounded-lg text-xs"
                                >
                                  <span className="font-medium">{variant.productName} — {variant.variantName}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const newIds = formData.targetConditions.products.variantIds.filter(id => id !== variantId);
                                      updateField('targetConditions.products.variantIds', newIds);
                                    }}
                                    className="text-blue-600 hover:text-blue-800"
                                  >
                                    <X size={14} />
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                          <button
                            type="button"
                            onClick={() => updateField('targetConditions.products.variantIds', [])}
                            className="text-xs text-red-600 hover:text-red-700 font-medium"
                          >
                            Clear all
                          </button>
                        </div>
                      )}

                      <input
                        type="text"
                        placeholder="Search variants by name, product, brand, or category..."
                        value={productSearch}
                        onChange={(e) => setProductSearch(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                      />

                      {productSearch && (
                        <div ref={dropdownRef} className="max-h-60 overflow-y-auto border border-gray-200 rounded-lg bg-white shadow-lg">
                          {filteredVariants.length > 0 ? (
                            filteredVariants.map(variant => (
                              <label
                                key={variant._id}
                                className="flex items-start gap-3 p-3 hover:bg-gray-50 cursor-pointer border-b last:border-b-0"
                              >
                                <input
                                  type="checkbox"
                                  checked={formData.targetConditions.products.variantIds.includes(variant._id)}
                                  onChange={(e) => {
                                    const current = formData.targetConditions.products.variantIds;
                                    const newIds = e.target.checked
                                      ? [...current, variant._id]
                                      : current.filter(id => id !== variant._id);
                                    updateField('targetConditions.products.variantIds', newIds);
                                  }}
                                  className="mt-1 w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                                />
                                <div className="flex-1 min-w-0">
                                  <div className="text-sm font-medium text-gray-900 truncate">
                                    {variant.productName} — {variant.variantName}
                                    {variant.vol && ` (${variant.vol})`}
                                  </div>
                                  <div className="text-xs text-gray-500 mt-1">
                                    {variant.brand?.brandName} • {variant.category?.collection_name}
                                    {variant.subCategory?.sub_collection_name && ` • ${variant.subCategory.sub_collection_name}`}
                                  </div>
                                </div>
                              </label>
                            ))
                          ) : (
                            <div className="p-4 text-center text-sm text-gray-500">
                              No variants found
                            </div>
                          )}
                        </div>
                      )}

                      {!productSearch && formData.targetConditions.products.variantIds.length === 0 && (
                        <div className="text-xs text-gray-500 text-center py-2">
                          Start typing to search and select variants
                        </div>
                      )}
                    </div>
                  )}
                </div>


                <div className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <Tag size={20} className="text-green-600" />
                      <span className="font-medium text-gray-900">Categories</span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.targetConditions.categories.enabled}
                        onChange={(e) => { updateField('targetConditions.categories.enabled', e.target.checked); setCategoryDrop(true) }}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                  {formData.targetConditions.categories.enabled && (
                    <div className="space-y-3">

                      {formData.targetConditions.categories.categoryIds.length > 0 && (
                        <div className="space-y-2">
                          <div className="text-xs font-medium text-gray-700">
                            Selected Categories ({formData.targetConditions.categories.categoryIds.length}):
                          </div>
                          <div className="flex flex-wrap gap-2 max-h-40 overflow-y-auto p-2 bg-gray-50 rounded-lg">
                            {formData.targetConditions.categories.categoryIds.map(categoryId => {
                              const category = collectionData.find(c => c._id === categoryId);
                              if (!category) return null;
                              return (
                                <div
                                  key={categoryId}
                                  className="flex items-center gap-2 bg-green-100 text-green-800 px-3 py-1.5 rounded-lg text-xs"
                                >
                                  <span className="font-medium">{category.collection_name}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const newIds = formData.targetConditions.categories.categoryIds.filter(id => id !== categoryId);
                                      updateField('targetConditions.categories.categoryIds', newIds);
                                    }}
                                    className="text-green-600 hover:text-green-800"
                                  >
                                    <X size={14} />
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                          <button
                            type="button"
                            onClick={() => updateField('targetConditions.categories.categoryIds', [])}
                            className="text-xs text-red-600 hover:text-red-700 font-medium"
                          >
                            Clear all
                          </button>
                        </div>
                      )}

                      {categoryDrop && <div ref={dropdownCatRef} className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg bg-white">
                        {collectionData.length > 0 ? (
                          collectionData.map(category => (
                            <label
                              key={category._id}
                              className="flex items-center gap-3 p-3 hover:bg-gray-50 cursor-pointer border-b last:border-b-0"
                            >

                              <input
                                type="checkbox"
                                checked={formData.targetConditions.categories.categoryIds.includes(category._id)}
                                onChange={(e) => {
                                  const current = formData.targetConditions.categories.categoryIds;
                                  const newIds = e.target.checked
                                    ? [...current, category._id]
                                    : current.filter(id => id !== category._id);
                                  updateField('targetConditions.categories.categoryIds', newIds);
                                }}
                                className="w-4 h-4 text-green-600 rounded focus:ring-2 focus:ring-green-500"
                              />
                              <span className="text-sm font-medium text-gray-900">
                                {category.collection_name}
                              </span>
                            </label>
                          ))
                        ) : (
                          <div className="p-4 text-center text-sm text-gray-500">
                            No categories available
                          </div>
                        )}
                      </div>}
                    </div>
                  )}
                </div>

                <div className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <Calendar size={20} className="text-purple-600" />
                      <span className="font-medium text-gray-900">Sales Channels</span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.targetConditions.channels.enabled}
                        onChange={(e) => updateField('targetConditions.channels.enabled', e.target.checked)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                  {formData.targetConditions.channels.enabled && (
                    <div className="flex gap-2">
                      {['website', 'app'].map(channel => (
                        <button
                          key={channel}
                          type="button"
                          onClick={() => {
                            const current = formData.targetConditions.channels.channelList;
                            const newList = current.includes(channel)
                              ? current.filter(c => c !== channel)
                              : [...current, channel];
                            updateField('targetConditions.channels.channelList', newList);
                          }}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${formData.targetConditions.channels.channelList.includes(channel)
                              ? 'bg-[#d3178a] text-white'
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                        >
                          {channel.toUpperCase()}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                {/* //================== */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <Package size={20} className="text-blue-600" />
                      <span className="font-medium text-gray-900"> Customer Tags</span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.targetConditions.customerTags.enabled}
                        onChange={(e) => updateField('targetConditions.customerTags.enabled', e.target.checked)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                  {formData.targetConditions.customerTags.enabled && (
                    <div className="space-y-3" >

                      {formData.targetConditions.customerTags.tagIds.length > 0 && (
                        <div className="space-y-2">
                          <div className="text-xs font-medium text-gray-700">
                            Selected Products ({formData.targetConditions.customerTags.tagIds.length}):
                          </div>
                          <div className="flex flex-wrap gap-2 max-h-40 overflow-y-auto p-2 bg-gray-50 rounded-lg">
                            {formData.targetConditions.customerTags.tagIds.map(tagId => {
                              const tag = tagsData.find(t => t._id === tagId);
                              if (!tag) return null;
                              return (
                                <div
                                  key={tagId}
                                  className="flex items-center gap-2 bg-blue-100 text-blue-800 px-3 py-1.5 rounded-lg text-xs"
                                >
                                  <span className="font-medium">{tag?.name}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const newIds = formData.targetConditions.customerTags.tagIds.filter(id => id !== tagId);
                                      updateField('targetConditions.customerTags.tagIds', newIds);
                                    }}
                                    className="text-blue-600 hover:text-blue-800"
                                  >
                                    <X size={14} />
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                          <button
                            type="button"
                            onClick={() => updateField('targetConditions.customerTags.tagIds', [])}
                            className="text-xs text-red-600 hover:text-red-700 font-medium"
                          >
                            Clear all
                          </button>
                        </div>
                      )}

                      <input
                        type="text"
                        placeholder="Search customerTags by name, brand, or category..."
                        value={tagSearch}
                        onChange={(e) => setTagSearch(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                      />

                      {tagSearch && (
                        <div ref={dropdownTagRef} className="max-h-60 overflow-y-auto border border-gray-200 rounded-lg bg-white shadow-lg">
                          {filteredTags.length > 0 ? (
                            filteredTags.map(tag => (
                              <label
                                key={tag._id}
                                className="flex items-start gap-3 p-3 hover:bg-gray-50 cursor-pointer border-b last:border-b-0"
                              >
                                <input
                                  type="checkbox"
                                  checked={formData.targetConditions.customerTags.tagIds.includes(tag._id)}
                                  onChange={(e) => {
                                    const current = formData.targetConditions.customerTags.tagIds;
                                    const newIds = e.target.checked
                                      ? [...current, tag._id]
                                      : current.filter(id => id !== tag._id);
                                    updateField('targetConditions.customerTags.tagIds', newIds);
                                  }}
                                  className="mt-1 w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                                />
                                <div className="flex-1 min-w-0">
                                  <div className="text-sm font-medium text-gray-900 truncate">
                                    {tag.name}
                                  </div>
                                  <div className="text-xs text-gray-500 mt-1">
                                    {tag.category}
                                  </div>
                                </div>
                              </label>
                            ))
                          ) : (
                            <div className="p-4 text-center text-sm text-gray-500">
                              No customerTags found
                            </div>
                          )}
                        </div>
                      )}

                      {!tagSearch && formData.targetConditions.customerTags.tagIds.length === 0 && (
                        <div className="text-xs text-gray-500 text-center py-2">
                          Start typing to search and select customerTags
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {/* //=================== */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <Gift size={20} className="text-red-600" />
                      <span className="font-medium text-gray-900">Order Criteria</span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.targetConditions.orderCriteria.enabled}
                        onChange={(e) => updateField('targetConditions.orderCriteria.enabled', e.target.checked)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                  {formData.targetConditions.orderCriteria.enabled && (
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Min Order Value ($)</label>
                        <input
                          type="number"
                          value={formData.targetConditions.orderCriteria.minOrderValue}
                          onChange={(e) => updateField('targetConditions.orderCriteria.minOrderValue', e.target.value)}
                          placeholder="0"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Max Order Value ($)</label>
                        <input
                          type="number"
                          value={formData.targetConditions.orderCriteria.maxOrderValue}
                          onChange={(e) => updateField('targetConditions.orderCriteria.maxOrderValue', e.target.value)}
                          placeholder="No limit"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {step === 3 && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Boost Configuration</h3>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">Boost Type *</label>
                  <div className="grid grid-cols-3 gap-4">
                    <button
                      type="button"
                      onClick={() => updateField('boostType', 'multiplier')}
                      className={`p-4 border-2 rounded-lg transition ${formData.boostType === 'multiplier' ? 'border-blue-600 bg-blue-50' : 'border-gray-200 hover:border-gray-300'
                        }`}
                    >
                      <Percent className="mx-auto mb-2 text-blue-600" size={24} />
                      <div className="font-medium text-sm">Multiplier</div>
                      <div className="text-xs text-gray-500 mt-1">2x, 3x points</div>
                    </button>

                    <button
                      type="button"
                      onClick={() => updateField('boostType', 'fixed_extra')}
                      className={`p-4 border-2 rounded-lg transition ${formData.boostType === 'fixed_extra' ? 'border-blue-600 bg-blue-50' : 'border-gray-200 hover:border-gray-300'
                        }`}
                    >
                      <Gift className="mx-auto mb-2 text-green-600" size={24} />
                      <div className="font-medium text-sm">Fixed Extra</div>
                      <div className="text-xs text-gray-500 mt-1">+200 points</div>
                    </button>

                    <button
                      type="button"
                      onClick={() => updateField('boostType', 'replace_base')}
                      className={`p-4 border-2 rounded-lg transition ${formData.boostType === 'replace_base' ? 'border-blue-600 bg-blue-50' : 'border-gray-200 hover:border-gray-300'
                        }`}
                    >
                      <TrendingUp className="mx-auto mb-2 text-purple-600" size={24} />
                      <div className="font-medium text-sm">Replace Base</div>
                      <div className="text-xs text-gray-500 mt-1">10 pts per $</div>
                    </button>
                  </div>
                </div>

                {formData.boostType === 'multiplier' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Multiplier *</label>
                    <input
                      type="number"
                      step="0.1"
                      min="1"
                      //   required
                      value={formData.boostValue.multiplier}
                      onChange={(e) => updateField('boostValue.multiplier', parseFloat(e.target.value))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="e.g., 2 for 2x, 1.5 for 1.5x"
                    />
                  </div>
                )}

                {formData.boostType === 'fixed_extra' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Extra Points *</label>
                    <input
                      type="number"
                      min="1"
                      //   required
                      value={formData.boostValue.fixedPoints}
                      onChange={(e) => updateField('boostValue.fixedPoints', parseInt(e.target.value))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="e.g., 200"
                    />
                  </div>
                )}

                {formData.boostType === 'replace_base' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Points Per Dollar *</label>
                    <input
                      type="number"
                      min="1"
                      //   required
                      value={formData.boostValue.replacementRate}
                      onChange={(e) => updateField('boostValue.replacementRate', parseInt(e.target.value))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="e.g., 10"
                    />
                  </div>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Badge Text (shown to customers)</label>
                  <input
                    type="text"
                    value={formData.badgeText}
                    onChange={(e) => updateField('badgeText', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    placeholder="e.g., 2X POINTS, +200 BONUS"
                  />
                </div>

                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div>
                    <div className="font-medium text-gray-900">Display to Customers</div>
                    <div className="text-sm text-gray-600">Show this promotion in customer-facing UI</div>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.displayToCustomers}
                      onChange={(e) => updateField('displayToCustomers', e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                  </label>
                </div>
              </div>
            )}

            {step === 4 && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Limits & Stacking</h3>

                <div className="border border-gray-200 rounded-lg p-4 space-y-4">
                  <h4 className="font-medium text-gray-900">Campaign Limits</h4>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Max Points Per Order</label>
                      <input
                        type="number"
                        value={formData.caps.maxPointsPerOrder}
                        onChange={(e) => updateField('caps.maxPointsPerOrder', e.target.value)}
                        placeholder="No limit"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Max Points Per Customer</label>
                      <input
                        type="number"
                        value={formData.caps.maxPointsPerCustomer}
                        onChange={(e) => updateField('caps.maxPointsPerCustomer', e.target.value)}
                        placeholder="No limit"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Reset Period</label>
                    <select
                      value={formData.caps.resetPeriod}
                      onChange={(e) => updateField('caps.resetPeriod', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                    >
                      <option value="none">No Reset (One-time limit)</option>
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="campaign">Campaign Duration</option>
                    </select>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Max Uses Per Customer</label>
                      <input
                        type="number"
                        value={formData.caps.maxUsesPerCustomer}
                        onChange={(e) => updateField('caps.maxUsesPerCustomer', e.target.value)}
                        placeholder="No limit"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Max Total Uses</label>
                      <input
                        type="number"
                        value={formData.caps.maxTotalUses}
                        onChange={(e) => updateField('caps.maxTotalUses', e.target.value)}
                        placeholder="No limit"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      />
                    </div>
                  </div>

                  <div className="pt-4 border-t">
                    <div className="flex items-center justify-between mb-2">
                      <label className="text-sm font-medium text-gray-700">Global Points Limit</label>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={formData.caps.globalLimit.enabled}
                          onChange={(e) => updateField('caps.globalLimit.enabled', e.target.checked)}
                          className="sr-only peer"
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>
                    {formData.caps.globalLimit.enabled && (
                      <input
                        type="number"
                        value={formData.caps.globalLimit.maxTotalPoints}
                        onChange={(e) => updateField('caps.globalLimit.maxTotalPoints', e.target.value)}
                        placeholder="e.g., 100000"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      />
                    )}
                    <p className="text-xs text-gray-500 mt-1">Campaign auto-pauses when limit reached</p>
                  </div>
                </div>

                <div className="border border-gray-200 rounded-lg p-4 space-y-4">
                  <h4 className="font-medium text-gray-900">Stacking Rules</h4>

                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div>
                      <div className="text-sm font-medium text-gray-900">Allow Stacking</div>
                      <div className="text-xs text-gray-600">Can combine with other campaigns</div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.stacking.allowStacking}
                        onChange={(e) => updateField('stacking.allowStacking', e.target.checked)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Priority (1-10)</label>
                    <input
                      type="number"
                      min="1"
                      max="10"
                      value={formData.stacking.priority}
                      onChange={(e) => updateField('stacking.priority', parseInt(e.target.value))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                    />
                    <p className="text-xs text-gray-500 mt-1">Higher priority campaigns are checked first</p>
                  </div>

                  {formData.stacking.allowStacking && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Stacking Mode</label>
                      <select
                        value={formData.stacking.stackingMode}
                        onChange={(e) => updateField('stacking.stackingMode', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                      >
                        <option value="multiplicative">Multiplicative (2x*base + 3x*base = 5x*base)</option>
                        <option value="additive">Additive (2x + 3x = 4x)</option>
                        <option value="highest_only">Highest Only (max value)</option>
                      </select>
                    </div>
                  )}

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs">
                    <div className="font-medium text-blue-900 mb-1">💡 Stacking Example:</div>
                    <div className="text-blue-700">
                      If multiple campaigns apply (e.g., Weekend 2x + App 3x):
                      <ul className="mt-1 ml-4 space-y-1">
                        <li>• <strong>Multiplicative:</strong> 100 pts × 2 +100 pts × 3 = 500 pts</li>
                        <li>• <strong>Additive:</strong> 100 pts × (2 + 3 - 1) = 400 pts</li>
                        <li>• <strong>Highest Only:</strong> 100 pts × 3 = 300 pts</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="sticky bottom-0 bg-white border-t px-6 py-4 flex justify-between">
            <button
              type="button"
              onClick={() => step > 1 ? setStep(step - 1) : onClose()}
              className="px-4 py-2 text-gray-700 hover:text-gray-900"
            >
              {step > 1 ? 'Back' : 'Cancel'}
            </button>

            <div className="flex gap-2">
              {step < 4 ? (
                <button
                  type="button"
                  //   onClick={() => setStep(step + 1)}
                  onClick={(e) => {
                    console.log('Current step:', step);
                    console.log('Moving to step:', step + 1);
                    e.preventDefault()
                    setStep(step + 1);
                  }}
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                >
                  Next
                </button>
              ) : (
                <button
                  type="submit"
                  className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                >
                  {editData ? "Update Campaign" : "Create Campaign"}
                </button>

              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCampaignModal;